export default class Sns {
    constructor(manager){

        //dom
        this.$sns = document.getElementById("l-footer__sns");

    }
    init(param) {
        if (param === 'show') {
            TweenMax.to(this.$sns, 1.2, {
                opacity: 1,
                display: 'flex',
                ease: Power2.easeOut,
            });
        } else {
            TweenMax.to(this.$sns, .6 ,{
                opacity: 0,
                display: 'none',
                ease: Power2.easeOut,
            });
        }
    }

}